import { Attributes } from 'src/components/organisms';

export type ParameterType = keyof Attributes | '';

export const getAttributesOptions = (
  parameter: ParameterType,
  parameterOptionsValue:
    | {
        value: string | number | boolean;
        label: string | number;
      }[]
    | undefined,
  attributes: Attributes,
) => {
  const noSelectedParameter = parameter === '';
  if (noSelectedParameter) {
    return [];
  }

  const anonymousValueChosen =
    parameter === 'anonymous' && parameterOptionsValue?.length;

  if (anonymousValueChosen) {
    return parameterOptionsValue;
  }

  return attributes[parameter] ?? [];
};
